import React from 'react'
import ReactDOM from 'react-dom'
import LoadingUIBlockerContainer from './components/LoadingUIBlockerContainer'
import './index.css'
import App from './applications/App'
import reportWebVitals from './reportWebVitals'
import ReduxProvider from './store/ReduxProvider'
import store from './store/store'
import '@submittable/ui-components/dist/index.css'
import '@submittable/ui-components/dist/externals.min.css'

ReactDOM.render(
  <ReduxProvider reduxStore={store}>
    <React.StrictMode>
      <App />
      <LoadingUIBlockerContainer />
    </React.StrictMode>
  </ReduxProvider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
